import { Menu } from 'antd';
import Hamburger from 'hamburger-react';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AuthService from 'services/AuthService';
import LogoSVG from 'static/images/adaya-logo_dark.svg';
import AccountMenu from './AccountMenu';
import { footerMenuItems, menuItems } from './menuConfig';
import './styles.scss';

const { SubMenu } = Menu;

const MenuItemIcon = (props) => {
    return (
        <div className="menu-item-icon">
            <span style={{
                backgroundImage: `url(${props.icon})`,
                width: props.iconWidth
            }}
            />
        </div>
    );
};

const SideMenu = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [user, setUser] = useState(props.auth.user || AuthService.getCurrentUser());
    const [accountAge, setAccountAge] = useState(0);
    const [selectedKeys, setSelectedKeys] = useState([]);
    const [selectedFooterKeys, setSelectedFooterKeys] = useState([]);
    const [menuOpen, setMenuOpen] = useState(false);
    const [screenSize, getDimension] = useState({
        dynamicWidth: window.innerWidth,
        dynamicHeight: window.innerHeight
    });

    const setDimension = () => {
        getDimension({
            dynamicWidth: window.innerWidth,
            dynamicHeight: window.innerHeight
        });
    };

    useEffect(() => {
        window.addEventListener('resize', setDimension);
        return (() => {
            window.removeEventListener('resize', setDimension);
        });
    }, [screenSize]);

    useEffect(() => {
        if (props.auth.user && props.auth.authFinished) {
            setUser(props.auth.user);
            let age = props.auth.getAccountAge();
            setAccountAge(age);
        }
    }, [props.auth.user, props.auth.authFinished]);

    useEffect(() => {
        const pathname = location.pathname;

        let selectedKey = false;
        for (let i = 0; i < menuItems.length; i += 1) {
            if (menuItems[i].sub) {
                const items = menuItems[i].sub.filter(sub => sub.link === pathname);
                if (items.length > 0) {
                    selectedKey = true;
                    setSelectedFooterKeys([]);
                    setSelectedKeys([items[0].key]);
                    if (items[0].hideMenu) setMenuOpen(false);
                    return;
                }
            } else {
                if (menuItems[i].link === pathname) {
                    selectedKey = true;
                    setSelectedFooterKeys([]);
                    setSelectedKeys([menuItems[i].key]);
                    if (menuItems[0]) setMenuOpen(false);
                    return;
                }
            }
        }

        if (!selectedKey) {
            const items = footerMenuItems.filter(item => item.link === pathname);
            if (items.length > 0) {
                setSelectedKeys([]);
                setSelectedFooterKeys([items[0].key]);
            }
        }

    }, [location]);

    const handleClick = e => {
        const keyPath = e.keyPath;
        let de = e.domEvent;
        console.log(`menu click`, de)
        if (de) {
            // allow middle clicks to open nav links to new window
            const isMiddle = (de && (de.which == 2 || de.button == 4));
            if (!isMiddle) de.preventDefault();
        }

        if (keyPath.length === 2) {
            const parent = menuItems.filter(menu => menu.key === keyPath[1])[0];
            const sub = parent.sub.filter(sub => sub.key === keyPath[0])[0];
            navigate(sub.link);
            setMenuOpen(false);
        } else if (keyPath.length === 1) {
            setMenuOpen(false);
            switch (keyPath[0]) {
                case 'help':
                    break;
                default:
                    navigate(keyPath[0]);
                    break;
            }
        }
    };

    if (!props.auth.loggedIn) {
        return null;
    }

    return (
        <div id="side-menu" className={menuOpen ? 'menu-opened' : ''}>

            <div className="menu-header">
                <img src={LogoSVG} />
                <Hamburger color="white" size={20} toggled={menuOpen} toggle={setMenuOpen} />
            </div>

            {(menuOpen || screenSize.dynamicWidth > 1024) &&
                <div className="menu-links-container">

                    <div className="menu-content">
                        <AccountMenu {...props} />
                        <nav className="v4-nav">
                            {(() => {
                                const renderItem = (item, groupIcon) => {
                                    const active = item.link === location.pathname;
                                    return (
                                        <button key={item.key} className={'v4-nav-item' + (active ? ' active' : '')}
                                            onClick={() => { navigate(item.link); setMenuOpen(false); }}>
                                            <span className="v4-nav-ico">{active && <i style={{ backgroundImage: `url(${groupIcon})` }} />}</span>
                                            <span className="v4-nav-txt">{item.label}</span>
                                        </button>
                                    );
                                };
                                return menuItems.flatMap(menu => menu.sub
                                    ? menu.sub.map(s => renderItem(s, menu.icon))
                                    : renderItem(menu, menu.icon));
                            })()}
                        </nav>
                    </div>

                    <div className="menu-footer">
                        <nav className="v4-navf">
                            {footerMenuItems.map(menu => (
                                (!menu.require || (menu.require && menu.require({ user }))) ? (
                                    <button key={menu.key} className={'v4-navf-item' + (menu.link === location.pathname ? ' active' : '')}
                                        onClick={() => { if (menu.key !== 'help') navigate(menu.link); setMenuOpen(false); }}>
                                        {menu.label}
                                    </button>
                                ) : null
                            ))}
                        </nav>
                    </div>

                </div>
            }
        </div>
    );
};

export default SideMenu;
